export default __webpack_public_path__ + "h5.png";